module.exports = __webpack_public_path__ + "img/service-tel.20ef70f1.png";